// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.webanalytics.RentalManagerUserPropertyWebAnalyticsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, WebAnalyticsWebResponseDto } from '../..';

interface GetParams {
  includeLeases?: boolean;
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Path =
  '/api/web/v1/users/properties/webAnalytics/get';

/**
 * Get listing web analytics data for web clients
 */
export const RentalManagerUserPropertyWebAnalyticsWebApiHandler_get = (getParams: GetParams, client = getClient()) => {
  return httpFrontEndRequest<GetParams, never, WebAnalyticsWebResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyWebAnalyticsWebApiHandler_get_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
